import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import classnames from 'classnames';
import s from './Flex.scss';
class Flex extends React.Component {
    render() {
        const props = this.props;
        const classNames = classnames(s['flex'], props.inline && s['inline'], props.justifyContent && s[`justify-content-${props.justifyContent}`], props.alignItems && s[`align-items-${props.alignItems}`], props.direction && s[`direction-${props.direction}`], props.wrap && s[`wrap-${props.wrap}`], props.fullWidth && s['full-width'], props.fullHeight && s['full-height'], props.className);
        return /*#__PURE__*/ React.createElement("div", {
            className: classNames,
            role: props.role,
            style: props.style || props.gap ? _object_spread({
                gap: props.gap
            }, props.style) : undefined,
            "data-hook": props.dataHook,
            onClick: props.onClick,
            ref: props.innerRef,
            "aria-label": props['aria-label']
        }, this.props.children);
    }
}
export default Flex;
